import { Box, IconButton, Paper } from '@mui/material';
import { VyIcon } from '@weft/icons';
import type { Plan, SyncStatus } from '@weft/types';
import { type ContractStatus, CONTRACT_STATUSES } from '@weft/types';
import React from 'react';
import { ContractNavbar } from './ContractNavbar';
import { ContractPageHeaderMenu } from './ContractPageHeaderMenu/ContractPageHeaderMenu';
import { ContractPageTitle } from './ContractPageTitle';

type ContractPageHeaderProps = {
  customerName: string;
  contractId: string;
  plan: Plan;
  status: ContractStatus;
  syncStatus: SyncStatus;
  contractStartDate: Date;
  contractEndDate?: Date;
};

export const ContractPageHeader: React.FC<ContractPageHeaderProps> = ({
  customerName,
  contractId,
  plan,
  status,
  syncStatus,
  contractStartDate,
  contractEndDate,
}) => {
  return (
    <>
      <Paper
        sx={{
          mb: 4,
          border: 'none',
          width: '100%',
          borderRadius: '8px',
          padding: '14px',
        }}
        elevation={1}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '20px',
          }}
        >
          <Box sx={{ width: '500px' }}>
            <ContractPageTitle plan={plan} />
          </Box>

          <ContractNavbar
            contractId={contractId}
            plan={plan}
            description={plan.description}
            contractEndDate={contractEndDate}
            status={status}
          />

          <ContractPageHeaderMenu
            contractId={contractId}
            planId={plan.id}
            planName={plan.name}
            billingData={plan.billingData}
            isActive={status === CONTRACT_STATUSES.Active}
            isTerminated={status === CONTRACT_STATUSES.Terminated}
            customerName={customerName}
            contractStartDate={contractStartDate}
            contractEndDate={contractEndDate}
            contractName={plan.name}
            menuAnchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            menuTransformOrigin={{ horizontal: 'right', vertical: 'top' }}
            syncStatus={syncStatus}
          >
            <IconButton>
              <VyIcon icon="DotsMenu" />
            </IconButton>
          </ContractPageHeaderMenu>
        </Box>
      </Paper>
    </>
  );
};
